import { render, staticRenderFns } from "./ListProvide.vue?vue&type=template&id=649a8358&"
import script from "./ListProvide.vue?vue&type=script&lang=js&"
export * from "./ListProvide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports